import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography
} from '@mui/material'
import Partner from '../types/Partner'
import truncateText from '@/utils/truncateText'
import CONSTANTS from '@/constants'

type Props = {
  partners: Partner[]
  showCompanyName?: boolean
  onClick?: (partner: Partner) => void
  admin?: boolean
}

const styles = {
  container: {
    display: 'grid',
    gridTemplateColumns: {
      xs: 'repeat(1, 1fr)',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(3, 1fr)',
      lg: 'repeat(4, 1fr)'
    },
    gap: '20px'
  },
  cardActionArea: {
    minHeight: '100px'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}

const MAX_TEXT_LENGTH = 35
const PUBLISHER_TYPE = CONSTANTS.PARTNER_TYPE_PUBLISHER

const PartnersList = ({
  partners,
  showCompanyName = true,
  onClick = () => {},
  admin = true
}: Props) => {
  if (partners.length === 0) {
    return <></>
  }

  if (!admin) {
    return (
      <Box sx={styles.container}>
        {partners.map((partner) => (
          <Card key={partner.id}>
            <CardActionArea
              sx={styles.cardActionArea}
              onClick={() => onClick(partner)}
            >
              <CardContent sx={styles.cardContent}>
                <Typography component="strong">
                  {truncateText(
                    MAX_TEXT_LENGTH,
                    partner.type === PUBLISHER_TYPE
                      ? partner.name
                      : partner.company
                  )}
                </Typography>
                <Typography variant="overline">
                  {truncateText(MAX_TEXT_LENGTH, partner.type)}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ))}
      </Box>
    )
  }

  return (
    <Box sx={styles.container}>
      {partners.map((partner) => (
        <Card key={partner.id}>
          <CardActionArea
            sx={styles.cardActionArea}
            onClick={() => onClick(partner)}
          >
            <CardContent sx={styles.cardContent}>
              <Typography component="strong">
                {truncateText(MAX_TEXT_LENGTH, partner.name)}
              </Typography>
              {showCompanyName && (
                <Typography variant="overline">
                  {truncateText(MAX_TEXT_LENGTH, partner.company) || '-'}
                </Typography>
              )}
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </Box>
  )
}

export default PartnersList
